var __jsx = React.createElement;
import { useRouter } from 'next/router';
import React from 'react';
import { useCopy } from '@webtv/copy-provider';
import { ErrorModal } from './ErrorModal';
import { jsx as _jsx } from "react/jsx-runtime";
export var LoadingError = function LoadingError() {
  var router = useRouter(); // eslint-disable-next-line react-hooks/exhaustive-deps

  var onClick = React.useCallback(function () {
    return router.back();
  }, []);
  var titleCopy = useCopy('error.loadingError');
  var mainCtaCopy = useCopy('error.tryAgain');
  return /*#__PURE__*/_jsx(ErrorModal, {
    titleCopy: titleCopy,
    mainCtaCopy: mainCtaCopy,
    mainCta: onClick
  });
};